/**
 *
 * DropdownContainer
 *
 */
import React, { memo } from 'react';
import { Dropdown } from 'antd';
import dynamic from 'next/dynamic';
import { I_Menu } from '../MenuDropdown';

const MenuDropdownTypeColumn = dynamic(() => import('../MenuDropdown'));

interface Props {
  listMenu: I_Menu[];
  menuActive?: string[];
  placement?:
    | 'topLeft'
    | 'topCenter'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomCenter'
    | 'bottomRight';
  classNameDropdown?: string;
  onClick: ({ type }) => void;
  children?: React.ReactNode;
}

const DropdownContainer = memo(
  ({
    listMenu,
    menuActive,
    placement,
    classNameDropdown = '',
    onClick,
    children,
  }: Props) => {
    return (
      <Dropdown
        overlay={
          <MenuDropdownTypeColumn
            listMenu={listMenu}
            menuActive={menuActive}
            onTriggerAction={onClick}
          />
        }
        placement={placement || 'bottomCenter'}
        className={classNameDropdown}
      >
        {children}
      </Dropdown>
    );
  },
);

export default DropdownContainer;
